import { ActionButton } from '@practium/ui';
import styles from './PaymentMethodCard.module.css';

interface PaymentMethodCardProps {
	methodLabel: string;
	documentTypeLabel: string;
	documentValue: string;
	receiptUrl?: string | null;
}

export const PaymentMethodCard = ({
	methodLabel,
	documentTypeLabel,
	documentValue,
	receiptUrl,
}: PaymentMethodCardProps) => {
	return (
		<section className={styles.card}>
			<div className={styles.header}>
				<h3 className={styles.title}>Forma de pagamento</h3>
				{receiptUrl ? (
					<ActionButton
						text="Ver comprovante"
						onClick={() => window.open(receiptUrl, '_blank', 'noopener,noreferrer')}
					/>
				) : null}
			</div>
			<div className={styles.body}>
				<div className={styles.row}>
					<span className={styles.label}>Método</span>
					<span className={styles.value}>{methodLabel}</span>
				</div>
				<div className={styles.row}>
					<span className={styles.label}>{documentTypeLabel}</span>
					<span className={styles.value}>{documentValue}</span>
				</div>
			</div>
		</section>
	);
};
